import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { PROPERTY } from "./apiRoutes";

const mutateDeleteProperty = async ({
  id,
  communityId,
  reason,
}: {
  id: string;
  communityId: string;
  reason: string;
}) => {
  return await axiosAuth.delete(`${PROPERTY(communityId)}/${id}?reason=${reason}`);
};

const useDeletePropertyMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      id: string;
      communityId: string;
      reason: string;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateDeleteProperty,
    ...queryParams,
  });

export default useDeletePropertyMutation;
